// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"f9b6a27c","867":"c4570207","944":"6bd884b9"}[chunkId] + ".chunk.js";
};